import { PlanPastDueExamsCtrl } from './plan-past-due-exams.controller';

export const PlanPastDueExamsStepComponent = {
  controller: PlanPastDueExamsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./plan-past-due-exams.html'),
};
